import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./App.css";

// App entry point
createRoot(document.getElementById("root")!).render(<App />);
